import { request } from '@/api/client';
import type {
  BillingOptions,
  CancelSubscriptionResponse,
  CurrentSubscription,
  SubscriptionCheckoutResponse,
  SubscriptionManagementSessionResponse,
} from '@/types/billing';
import type { CustomerInvoiceDocumentResponse, CustomerInvoiceListResponse } from '@/types/payment';

export const billingService = {
  getOptions: (): Promise<BillingOptions> =>
    request<BillingOptions>('/billing/options', { method: 'GET', auth: true }),

  getInvoices: (params: { year: number; month: number }): Promise<CustomerInvoiceListResponse> => {
    const search = new URLSearchParams({
      year: String(params.year),
      month: String(params.month),
    });
    return request<CustomerInvoiceListResponse>(`/billing/invoices?${search.toString()}`, {
      method: 'GET',
      auth: true,
    });
  },

  getInvoiceDocument: (invoiceId: string): Promise<CustomerInvoiceDocumentResponse> =>
    request<CustomerInvoiceDocumentResponse>(`/billing/invoices/${invoiceId}/document`, {
      method: 'GET',
      auth: true,
    }),

  getCurrentSubscription: (): Promise<CurrentSubscription | null> =>
    request<CurrentSubscription | null>('/subscriptions/me', {
      method: 'GET',
      auth: true,
    }),

  createSubscriptionCheckout: (
    planVersionId: string,
    idempotencyKey: string
  ): Promise<SubscriptionCheckoutResponse> =>
    request<SubscriptionCheckoutResponse>('/subscriptions/checkout', {
      method: 'POST',
      auth: true,
      headers: { 'Idempotency-Key': idempotencyKey },
      body: JSON.stringify({ plan_version_id: planVersionId }),
    }),

  cancelRenewal: (): Promise<CancelSubscriptionResponse> =>
    request<CancelSubscriptionResponse>('/subscriptions/me/cancel', {
      method: 'POST',
      auth: true,
    }),

  createManagementSession: (): Promise<SubscriptionManagementSessionResponse> =>
    request<SubscriptionManagementSessionResponse>('/subscriptions/management-session', {
      method: 'POST',
      auth: true,
    }),
};
